export default {
  'toplst.type.tcode': {
    ko: 'T-code 목록',
    ja: 'Tコードリスト',
    en: 'T-code list',
    cn: '',
  },
  '': {
    ko: '',
    ja: '',
    en: '',
    cn: '',
  },
  'unulst.ttl.mandt': {
    ko: 'Client',
    ja: 'クライアント',
    en: 'Client',
    cn: '',
  },
  'unulst.ttl.desc': {
    ko: 'Description',
    ja: '説明',
    en: 'Description',
    cn: '',
  },
  'toplst.ttl.rank': {
    ko: '순위',
    ja: '順位',
    en: 'Ranking',
    cn: '',
  },
  'toplst.type.report': {
    ko: 'Report 목록',
    ja: 'レポートリスト',
    en: 'Report list',
    cn: '',
  },
  'toplst.tab.ttl.unused': {
    ko: 'Unused',
    ja: '未使用',
    en: 'Unused',
    cn: '',
  },
  'toplst.ttl.avg.db.time': {
    ko: 'Ø DB Time (ms)',
    ja: 'Ø DB時間(ms)',
    en: 'Ø DB Time (ms)',
    cn: '',
  },
  'unulst.ttl.top.report': {
    ko: 'Unused Reports',
    ja: '未使用のレポート',
    en: 'Unused Reports',
    cn: '',
  },
  'toplst.ttl.cnt': {
    ko: '건수',
    ja: '件数',
    en: 'Count',
    cn: '',
  },
  'toplst.ttl.rpt': {
    ko: 'Report',
    ja: 'レポート',
    en: 'Report',
    cn: '',
  },
  'unulst.filter.report': {
    ko: "Report 조건 입력 ('%' 허용)",
    ja: "レポート条件を入力('％'許可)",
    en: "Enter a Report... (with '%')",
    cn: '',
  },
  'toplst.tab.ttl.rt': {
    ko: 'Top Response Time',
    ja: 'トップ応答時間',
    en: 'Top Response Time',
    cn: '',
  },
  'toplst.tab.ttl.exe': {
    ko: 'Top Execution',
    ja: 'トップ実行',
    en: 'Top Execution',
    cn: '',
  },
  'toplst.ttl.avg.rt': {
    ko: 'Ø R.T. (ms)',
    ja: 'Ø R.T.(ms)',
    en: 'Ø R.T. (ms)',
    cn: '',
  },
  'toplst.tab.ttl.mem': {
    ko: 'Top Memory',
    en: 'Top Memory',
  },
  'unulst.ttl.top.tcode': {
    ko: 'Unused T-codes',
    ja: '未使用のTコード',
    en: 'Unused T-codes',
    cn: '',
  },
  'toplst.ttl.top.db': {
    ko: 'Top DB Time {cboStr}',
    ja: 'トップDB時間{cboStr}',
    en: 'Top DB Time {cboStr}',
    cn: '',
  },
  'toplst.ttl.ctxt.menu.pgm': {
    ko: 'View Program history',
    ja: 'ビュープログラム履歴',
    en: 'View Program history',
    cn: '',
  },
  'toplst.ttl.tcode': {
    ko: 'T-Code',
    ja: 'Tコード',
    en: 'T-Code',
    cn: '',
  },
  'toplst.ttl.top.rt': {
    ko: 'Top Response Time {cboStr}',
    ja: 'トップ応答時間{cboStr}',
    en: 'Top Response Time {cboStr}',
    cn: '',
  },
  'unulst.ttl.tcode': {
    ko: 'T-code',
    ja: 'Tコード',
    en: 'T-code',
    cn: '',
  },
  'unulst.ttl.top.user': {
    ko: 'Unused Users',
    ja: '未使用のユーザー',
    en: 'Unused Users',
    cn: '',
  },
  'topexe.ttl.main': {
    ko: 'Top Execution {cboStr} [ {module} ]',
    ja: 'トップ実行{cboStr}[{module}]',
    en: 'Top Execution {cboStr} [ {module} ]',
    cn: '',
  },
  'unulst.ttl.bname': {
    ko: 'User',
    ja: 'ユーザー',
    en: 'User',
    cn: '',
  },
  'unulst.filter.user': {
    ko: "사용자ID 조건 입력 ('%' 허용)",
    ja: "ユーザーIDの条件を入力('％'許可)",
    en: "Enter a User ID... (with '%')",
    cn: '',
  },
  'toplst.ttl.top.cpu': {
    ko: 'Top CPU Time {cboStr}',
    ja: 'トップCPU時間{cboStr}',
    en: 'Top CPU Time {cboStr}',
    cn: '',
  },
  'unulst.ttl.report': {
    ko: 'Report',
    ja: 'レポート',
    en: 'Report',
    cn: '',
  },
  'unulst.filter.tcode': {
    ko: "T-Code 조건 입력 ('%' 허용)",
    ja: "Tコードの条件を入力('%'許可)",
    en: "Enter a T-Code... (with '%')",
    cn: '',
  },
  'toplst.ttl.avg.cpu.time': {
    ko: 'Ø CPU Time (ms)',
    ja: 'Ø CPU時間(ms)',
    en: 'Ø CPU Time (ms)',
    cn: '',
  },
  'unulst.filter.client': {
    ko: "Client 조건 입력 ('%' 허용)",
    ja: "クライアント条件を入力('％'許可)",
    en: "Enter a Client... (with '%')",
    cn: '',
  },
  'topmem.ttl.memsum': {
    ko: 'Top Total Memory Usage {cboStr}',
    en: 'Top Total Memory Usage {cboStr}',
  },
  'topmem.ttl.maxroll': {
    ko: 'Top Roll Area {cboStr}',
    en: 'Top Roll Area {cboStr}',
  },
  'topmem.ttl.maxpage': {
    ko: 'Top Paging Memory {cboStr}',
    en: 'Top Paging Memory {cboStr}',
  },
  'topmem.ttl.maxbytes': {
    ko: 'Top Max. Extended Memory (in Session) {cboStr}',
    en: 'Top Max. Extended Memory (in Session) {cboStr}',
  },
  'topmem.ttl.maxbytesdi': {
    ko: 'Top Max. Extended Memory (in Step) {cboStr}',
    en: 'Top Max. Extended Memory (in Step) {cboStr}',
  },
  'topmem.ttl.usedbytes': {
    ko: 'Top Extended Memory {cboStr}',
    en: 'Top Extended Memory {cboStr}',
  },
  'topmem.ttl.privsum': {
    ko: 'Top Heap Memory {cboStr}',
    en: 'Top Heap Memory {cboStr}',
  },
  'topmem.ttl.avg.bytes': {
    ko: 'Ø Bytes',
    en: 'Ø Bytes',
  },
  'topmem.ttl.avg.pages': {
    ko: 'Ø Pages',
    en: 'Ø Pages',
  },
};
